import AppCardSidebarLayout from './AppCardSidebarLayout.vue';

export default AppCardSidebarLayout;



// WEBPACK FOOTER //
// ./src/uikit/layouts/cardlayouts/CardSidebarLayout/index.ts